interface ICategoryLocaleInfo {
    id: number;
    name: string;
    description: string;
}

const CATEGORY_LOCALE_INFO: ICategoryLocaleInfo[] = [
    { id: 1, name: 'games', description: 'games-description' },
    { id: 2, name: 'replenishment', description: 'replenishment-description' },
];

export default CATEGORY_LOCALE_INFO;
